import React, { useCallback, useContext, useState } from 'react';
import { IconButton, Tooltip } from '@material-ui/core';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import ProcedureCostDialog from './ProcedureCostDialog';
import { ProcedureCostDetailsInput } from './procedureCostMock';
import { SessionContext } from '@/state/Session';
import { useScope } from '@/hooks/useScope';
import UserRoles from '@/types/UserRoles';

type Props = ProcedureCostDetailsInput;

// Compound visibility gate (mirrors StaffCostAccess.tsx):
//   showStaffCost && (isSuperAdmin || staffCostAccess)
// Self-contained so callers (Procedure.jsx) don't have to thread
// scope/session props. Cost: O(1) context reads — `scope` is
// fetched once per scope load; the session context is shared
// app-wide. No per-button DB hits.
const ProcedureCostButton: React.FC<Props> = props => {
  const [open, setOpen] = useState(false);

  const scope = useScope();
  const sessionContext = useContext(SessionContext) as any;
  const roles = (sessionContext?.session?.user?.metadata ?? []) as string[];
  const isSuperAdmin = roles.indexOf(UserRoles.SuperAdmin) >= 0;
  //const staffCostAccess = !!sessionContext?.session?.account?.metadata?.staffCostAccess;
  const showStaffCost = !!scope?.hospital?.modules?.showStaffCost;

  // Enable when exposing to users with staffCostAccess role
  //const canShow = showStaffCost && (isSuperAdmin || staffCostAccess);
  const canShow = showStaffCost && isSuperAdmin;

  const handleOpen = useCallback((e: React.MouseEvent) => {
    e.stopPropagation();
    setOpen(true);
  }, []);

  const handleClose = useCallback(() => setOpen(false), []);

  if (!canShow) return null;

  return (
    <>
      <Tooltip title="Cost details">
        <IconButton size="small" onClick={handleOpen} aria-label="Cost details">
          <AttachMoneyIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      {open && <ProcedureCostDialog open={open} onClose={handleClose} {...props} />}
    </>
  );
};

export default ProcedureCostButton;
